import * as React from 'react';
import { ComponentProps } from 'ui/common';
import { FactLink } from 'app/area/case/components/fact-box/fact-link';
import { IconList } from 'ui';
import { toAbsoluteUrl } from 'app/infrastructure/hosting';
import { FactItemProps } from 'app/area/case/components/fact-box/types';
import { routeConstants } from 'app/routes/route-constants';


interface ConnectedCasesReportCategoryFactItemProps extends ComponentProps, FactItemProps { 
  url: string;
  title?: string;
  tooltip?: string;
  caseNumberDomain?: string;
  dashboardId?: string;
  openUrlInNewTab?: boolean;
  [key: string]: any;
}
export const ConnectedCasesReportCategoryFactItem = (props: ConnectedCasesReportCategoryFactItemProps) => {
  const { url, portalTarget, dashboardId, caseNumberDomain, tooltip, title, openUrlInNewTab } = props;
      
    if(!caseNumberDomain || !url) {
      return null;
    }

    let icons = undefined;
    let reportCategoryUrl = undefined;
    const params = new URLSearchParams();
    const match = url.match(/\/case\/(\d+)/);
    const connectedCaseId = match ? match[1] : null;

    if(!!Number(dashboardId)) {
      const iconDashboard = toAbsoluteUrl('i/dashboard.svg');
      icons = [{ description: tooltip, icon: iconDashboard, value: 0, propName: 'reportCategory' }];
      reportCategoryUrl = `${routeConstants.dashboardFor(Number(dashboardId))}`;
    }
    params.set('cd', `${caseNumberDomain};${connectedCaseId}`);
  
    return <>
      {!!reportCategoryUrl ? <FactLink id={props.componentId} classNames={`fact-item icon-line`} urlOpenNew={openUrlInNewTab}
        url={`${reportCategoryUrl}?${params.toString()}`} urlHrefNewTabOverride={`${reportCategoryUrl}?${params.toString()}`} params={props.params}>
        <IconList title={title} valueItems={icons} defaultIcon={undefined} portalTarget={portalTarget} />
      </FactLink> : null}
  </>;
};
